<div>
	<div class="left">
		<span class="bar-button section-back" [title]="'TO_START' | translate" (click)="previousSection($event)"></span>
		<span class="bar-button frame-back" [title]="'FRAME_BACK' | translate" (click)="previousFrame()"></span>
		<span class="bar-button play" [title]="'PLAY' | translate" *ngIf="!playing" (click)="play()"></span>
		<span class="bar-button pause" [title]="'PAUSE' | translate" *ngIf="playing" (click)="pause()"></span>
		<span class="bar-button frame-forward" [title]="'FRAME_FORWARD' | translate" (click)="nextFrame()"></span>
		<span class="bar-button section-forward" [title]="'TO_END' | translate" (click)="nextSection()"></span>
	</div>
	<div class="left timing">
		<span class="bar-text time">{{ currentTime }}</span><span class="bar-text separator">|</span><span class="bar-text">{{ duration }}</span>
	</div>
	<div class="left">
		<span class="bar-button volume" [class.muted]="muted" (click)="toggleMute()"></span>
	</div>
</div>
